import { render } from "./CleansPage.vue?vue&type=template&id=5c386dc8"
import script from "./CleansPage.vue?vue&type=script&lang=js"
export * from "./CleansPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__